/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '@/api/request';
export function codeGet(data) {
  return request.get('/stand/codeContent', {
    params: data
  });
}
export function codeLogin(data) {
  return request.post('/stand/codeLogin', data);
}
export function pwdLogin(data) {
  return request.post('/stand/pwdLogin', data);
}
export function pwdSet(data) {
  return request.post('/stand/codeLogin/password', data);
}
export function epListGet(data) {
  return request.get('/stand/login/epList', {
    params: data
  });
}
export function keepAlive(data) {
  return request.post('/stand/sessionUser/keepAlive', data);
}
export function logout(data) {
  return request.post('/logout', data);
}
export function changeEp(data) {
  return request.post('/stand/login/changeEp', data);
}
export function mobilePush(data) {
  return request.post('/stand/mobilePush', data);
}
export function userInfoChange(data) {
  return request.put('/stand/user', data);
}
export function addUser(data) {
  return request.post('/stand/user', data);
}
export function addUserRole(data) {
  return request.put('/user/addRole', {}, {
    params: data
  });
}
export function registerEnterprise(data) {
  return request.post('/stand/enterprise', data);
}
export function getRegisterProgress(data) {
  return request.get('/stand/enterprise/progress', {
    params: data
  });
}
export function getDeptList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request.get('/stand/dept/list', {
    params: data
  });
}
export function exportOrderPdf() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request.post('/export/orderPdf', data);
}
export function getVersionInfo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request.get('/version/info', {
    params: data
  });
}